/** Shared layout tokens for account / payment screens */
export const getPageStyles = (isDark) => ({
    page: {
        maxWidth: "480px",
        margin: "0 auto",
        minHeight: "100%",
        backgroundColor: isDark ? "#111827" : "#f8fafc",
        color: isDark ? "#f9fafb" : "#111827",
    },
    hero: (gradient) => ({
        background:
            gradient ||
            "linear-gradient(135deg, #6366f1 0%, #7c3aed 55%, #5b21b6 100%)",
        borderRadius: "16px",
        padding: "16px",
        boxShadow: isDark
            ? "0 12px 32px rgba(99, 102, 241, 0.28)"
            : "0 12px 28px rgba(99, 102, 241, 0.2)",
        color: "#fff",
    }),
    heroGreen:
        "linear-gradient(135deg, #16a34a 0%, #059669 50%, #047857 100%)",
    heroAmber:
        "linear-gradient(135deg, #f59e0b 0%, #d97706 50%, #b45309 100%)",
    heroTeal:
        "linear-gradient(135deg, #14b8a6 0%, #059669 100%)",
    card: {
        backgroundColor: isDark ? "#020617" : "#ffffff",
        borderRadius: "14px",
        border: `1px solid ${isDark ? "#1f2937" : "#e5e7eb"}`,
        boxShadow: isDark
            ? "0 4px 20px rgba(0,0,0,0.35)"
            : "0 4px 16px rgba(15, 23, 42, 0.06)",
        overflow: "hidden",
    },
    sectionTitle: {
        fontSize: "0.7rem",
        fontWeight: 700,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: isDark ? "#9ca3af" : "#6b7280",
        marginBottom: 0,
    },
    input: {
        backgroundColor: isDark ? "#0f172a" : "#f8fafc",
        color: isDark ? "#f9fafb" : "#111827",
        border: `1px solid ${isDark ? "#334155" : "#e2e8f0"}`,
        borderRadius: "10px",
    },
    textMuted: isDark ? "#9ca3af" : "#6b7280",
    listBorder: isDark ? "#1f2937" : "#f1f5f9",
    submitBtn: {
        borderRadius: "12px",
        padding: "12px 16px",
        fontWeight: 700,
        border: "none",
        background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
        color: "#fff",
        boxShadow: "0 6px 20px rgba(99, 102, 241, 0.35)",
    },
    outlineBtn: {
        borderRadius: "10px",
        fontWeight: 600,
        fontSize: "0.8rem",
        border: `1px solid ${isDark ? "#374151" : "#e5e7eb"}`,
        backgroundColor: isDark ? "#0f172a" : "#f8fafc",
        color: isDark ? "#e5e7eb" : "#374151",
    },
    filterChip: (active) => ({
        borderRadius: "10px",
        padding: "8px 14px",
        fontSize: "0.78rem",
        fontWeight: 600,
        border: active ? "none" : `1px solid ${isDark ? "#374151" : "#e5e7eb"}`,
        background: active
            ? "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)"
            : isDark
              ? "#0f172a"
              : "#ffffff",
        color: active ? "#fff" : isDark ? "#e5e7eb" : "#374151",
        cursor: "pointer",
        whiteSpace: "nowrap",
    }),
    modal: {
        backgroundColor: isDark ? "#020617" : "#ffffff",
        borderRadius: "16px",
        border: `1px solid ${isDark ? "#1f2937" : "#e5e7eb"}`,
        boxShadow: "0 24px 48px rgba(0,0,0,0.35)",
        color: isDark ? "#f9fafb" : "#111827",
    },
    notice: {
        borderRadius: "12px",
        padding: "12px 14px",
        backgroundColor: isDark ? "rgba(99, 102, 241, 0.12)" : "#eef2ff",
        border: `1px solid ${isDark ? "rgba(129, 140, 248, 0.35)" : "#c7d2fe"}`,
        fontSize: "0.8rem",
        color: isDark ? "#a5b4fc" : "#4338ca",
    },
    empty: {
        textAlign: "center",
        padding: "32px 16px",
        color: isDark ? "#9ca3af" : "#6b7280",
        fontSize: "0.9rem",
    },
});

export const MOTION = {
    container: {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { staggerChildren: 0.06, delayChildren: 0.04 } },
    },
    item: {
        hidden: { opacity: 0, y: 12 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.3, ease: "easeOut" } },
    },
};
